__turbopack_context__.v({
  "caption": "index-module__b4Eq8a__caption",
  "content": "index-module__b4Eq8a__content",
  "description": "index-module__b4Eq8a__description",
  "directions": "index-module__b4Eq8a__directions",
  "imgContainer": "index-module__b4Eq8a__imgContainer",
  "root": "index-module__b4Eq8a__root",
});
